import { defineMessages } from "@/i18n";
import en from "./en";

export const libScheduleMessages = defineMessages("lib-schedule", en);
